// @flow

import { observer } from "mobx-react";
import React from "react";

import AppearanceStore from "app/stores/AppearanceStore";
import TimelineCardSwitcher from "app/components/TimelineCardSwitcher/TimelineCardSwitcher";
import TimelineItemStore from "app/stores/TimelineItemStore";
import UserStore from "app/stores/UserStore";
import VideoStore from "app/stores/VideoStore";
import VideoPlayerStore from "app/stores/VideoPlayerStore";
import User from "app/models/User";

type Props = {
    serverTime: any
};

@observer
export default class TimelineCardSwitcherContainer extends React.Component<Props> {
    render() {
        const item: any = TimelineItemStore.selectedItem;
        const userId: ?number = UserStore.user ? UserStore.user.rowid : null;
        const user: ?User = UserStore.user;
        const verticalView = AppearanceStore.isMobile || AppearanceStore.embed;

        return (
            <TimelineCardSwitcher
                userId={userId}
                user={user}
                video={VideoStore.video}
                isOwner={VideoStore.isOwner}
                editable={VideoStore.isEditable}
                onRequestPauseMainVideo={VideoPlayerStore.pause}
                onSeek={VideoPlayerStore.seekTo}
                item={item}
                onSave={TimelineItemStore.save}
                onRequestEdit={TimelineItemStore.requestEdit}
                onCancelWizard={TimelineItemStore.requestWizardCancellation}
                onChange={TimelineItemStore.enableWizardChanged}
                wizard={TimelineItemStore.wizard}
                onReact={TimelineItemStore.saveReaction}
                onComment={TimelineItemStore.saveComment}
                onDelete={TimelineItemStore.remove}
                onDeleteComment={TimelineItemStore.deleteComment}
                serverTime={this.props.serverTime}
                scale={AppearanceStore.scale}
                progress={VideoPlayerStore.progress}
                isVerticalView={verticalView}
                onExpand={TimelineItemStore.expand}
                onUnExpand={TimelineItemStore.unExpand}
                isExpanded={TimelineItemStore.isExpanded}
                isOverlayVisible={TimelineItemStore.isOverlayVisible}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/TimelineCardSwitcherContainer.js